export default "__VITE_ASSET__1605f602__"